import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html'
})
export class RedirectComponent implements OnInit {
  
  constructor(
    private router:Router
  ) { }

  ngOnInit() {
    let url = this.router.url;
    const token = url.split('/redirect/')[1];
    let decodeObj={};
    if(token) {
        let base64Url = token.split('.')[1];
        if(base64Url) {
          let base64 = base64Url.replace('-', '+').replace('_', '/');
          decodeObj = JSON.parse(window.atob(base64));
          localStorage.setItem('token',token)
          localStorage.setItem('user_id', decodeObj['user_id']);
          this.router.navigate(['/home']);
        } else {
          localStorage.clear()
          this.router.navigate(['/login']);
        }
    } else {
      localStorage.clear();
      this.router.navigate(['/login']);
    }
  }
}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/redirect/redirect.component.ts